import { render, staticRenderFns } from "./CommonCard.vue?vue&type=template&id=60561a8e&scoped=true"
import script from "./CommonCard.vue?vue&type=script&lang=js"
export * from "./CommonCard.vue?vue&type=script&lang=js"
import style0 from "./CommonCard.vue?vue&type=style&index=0&id=60561a8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60561a8e",
  null
  
)

export default component.exports